// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Konstanten
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-field-block',
    inheritAttrs: false,
    // #endregion
    // #region Props
    props: {
        name: {
            type: String,
            required: false,
            default: null
        },
        label: {
            type: String,
            required: false,
            default: null
        },
        showLabel: {
            type: Boolean,
            required: false,
            default: true
        },
        helpText: {
            type: String,
            required: false,
            default: null
        },
        helpLink: {
            type: String,
            required: false,
            default: null
        },
        isInvalid: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        error: {
            type: [Object],
            required: false,
            default() {
                return null;
            }
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        isInherited: {
            type: Boolean,
            required: false,
            default: false
        },
        isInheritanceField: {
            type: Boolean,
            required: false,
            default: false
        },
        isAutoFill: {
            type: Boolean,
            required: false,
            default: false
        },
        disableInheritanceToggle: {
            type: Boolean,
            required: false,
            default: false
        },
        isStandalone: {
            type: Boolean,
            required: false,
            default: false
        },
        size: {
            type: String,
            required: false,
            default: 'default',
            validValues: ['small', 'medium', 'default'],
            validator(val) {
                return ['small', 'medium', 'default'].includes(val);
            }
        }
    },
    // #endregion
    // #region Data
    data: () => ({
        id: utils.createId(),
        hasFocus: false
    }),
    // #endregion
    // #region Computed
    computed: {
        identification() {
            if (this.name) {
                return this.name;
            }
            return `g-field--${this.id}`;
        },
        blockSize() {
            return `g-field--${this.size}`;
        },
        hasLabel() {
            return (!!this.label || !!this.helpText || this.isInheritanceField) && this.showLabel;
        },
        hasError() {
            return this.isInvalid || !!this.error;
        },
        fieldClasses() {
            return [{
                    'has--error': this.hasError,
                    'is--disabled': this.disabled,
                    'is--inherited': this.isInherited,
                    'is--autofill': this.isAutoFill,
                    'has--focus': this.hasFocus,
                    'is-standalone': this.isStandalone
                }, this.blockSize];
        },
        fieldLabelClasses() {
            return {
                'is--required': this.required
            };
        }
    },
    // #endregion
    // #region Methods
    methods: {
        setFocusClass() {
            this.hasFocus = true;
        },
        removeFocusClass() {
            this.hasFocus = false;
        }
    }
    // #endregion
});
// #endregion
